import React from 'react';
import {Helmet} from 'react-helmet';
import {makeStyles} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.paletteBackground.dark,
        minHeight: '100%',
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
}));

const Page = React.forwardRef<HTMLDivElement, {title: string; className?: string; children: React.ReactNode}>(
    (props, forwardedRef) => {
        const classes = useStyles();

        return (
            <div ref={forwardedRef} className={clsx(classes.root, props.className)}>
                <Helmet>
                    <title>{props.title}</title>
                </Helmet>
                {props.children}
            </div>
        );
    },
);

export default Page;
